<ng-container *transloco="let t">
  @if (isOpen()) {
    <ld-base-modal [title]="t('modalsPiitTransferTitle')" [showCloseButton]="false" (closeModal)="onRemindLater()">
      <div modal-content>
        <div id="piit-transfer-modal-message" class="mb-6">
          <p class="font-dm text-sm text-ld-neutral-500 leading-relaxed">
            Your loan servicing is being transferred to
            <span class="font-semibold text-ld-neutral">{{ newServicer() }}</span>
            effective on
            <span class="font-semibold text-ld-neutral">{{ transferDate() | date: 'MMMM d, yyyy' }}</span>
            .
          </p>
          <p class="font-dm text-sm text-ld-neutral-500 leading-relaxed mt-3">
            Please note that your payment address and contact information may change. You will receive additional
            information from your new servicer.
          </p>
        </div>
      </div>

      <div modal-footer>
        <button id="piit-transfer-dismiss-btn" type="button" class="btn-outline-ld-purple" (click)="onDismiss()">
          {{ t('commonButtonsNoThanks') }}
        </button>

        <button
          id="piit-transfer-remind-btn"
          type="button"
          class="btn-primary-ld-purple flex-1 py-3 px-4 text-sm"
          (click)="onRemindLater()"
        >
          {{ t('commonButtonsRemindLater') }}
        </button>
      </div>
    </ld-base-modal>
  }
</ng-container>
